import { render, staticRenderFns } from "./CommutatorDetails.vue?vue&type=template&id=a5e1c358&scoped=true&"
import script from "./CommutatorDetails.vue?vue&type=script&lang=js&"
export * from "./CommutatorDetails.vue?vue&type=script&lang=js&"
import style0 from "./CommutatorDetails.vue?vue&type=style&index=0&id=a5e1c358&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5e1c358",
  null
  
)

export default component.exports